import * as React from "react"
import "./styles.scss";
import {useState} from "react";

export default function ProductTabulate({tabListData,tabListDataIcons}) {
    const [tabulateActiveItem, setTabulateActiveItem] = useState(tabListDataIcons[0]);
    const productTabulateStaticData = {
        "organic_cotton": "Styles with this label are made using certified organic cotton grown without toxic pesticides and fertilisers to help support healthy soil and increase biodiversity",
        "closer_to_uk": "Styles with this label are manufactured less than 2,000 miles away from the UK, significantly reducing the total distance travelled compared to items manufactured elsewhere",
        "better_cotton": "Styles with this label support the Better Cotton Initiative. The cotton in these products is sourced via a system of mass balance and therefore may not contain Better Cotton",
        "transitional_cotton": "Styles with this label are made using transitional cotton which helps to maintain the future supply of organic cotton by supporting farmers in the transition to organic",
        "recycled_materials": "Styles with this label are made using at least 50% certified recycled materials",
        "lower_water": "",
        "plant_based_materials": "Styles with this label contain at least 50% responsibly sourced, plant-based materials produced using lower impact processes that minimise water usage",
        "responsible_linen": "Styles with this label are made using at least 50% certified responsible linen",
        "responsible_wool": "Styles with this label are made using at least 50% certified responsible wool",
    }

    return (
        <div>

            {tabListDataIcons && tabListDataIcons.length && (
                <div className={`tabulate-wrapper`}>


                    <div className={`tabulate-control`}>
                        {tabListDataIcons.map(tabulatItem => (
                            <div
                                className={`tabulate-control-item ${tabulatItem === tabulateActiveItem ? 'active' : ''}`}
                                onClick={() => {
                                    setTabulateActiveItem(tabulatItem === tabulateActiveItem ? null : tabulatItem)
                                }}>
                                <img
                                    src={`/static/images/icons/svg/${tabulatItem}.svg`}
                                    alt=""/>
                            </div>
                        ))}</div>
                    {tabulateActiveItem && (<div className={`tabulate-display`}>
                        {tabListData[tabulateActiveItem]}
                    </div>)}


                </div>
            )}
        </div>
    )
}
